import { Link } from '../../../api/contract-notice-dto';
import {
  BaseEntityDTO, BaseObjectDTO, DivisionDTO, DocumentClassDTO,
  TaskDTO
} from '../../../api/plyca-dtos';
import { AwardDTO, ObjectContextDTO, UnitPriceDTO } from '../../../api/plyca-dtos-v2';


export class CodeInclusionDTO implements BaseEntityDTO {
  documentClass: DocumentClassDTO;
  orderNumber: number;
  links: Link[];
  identifier: any;
  task: TaskDTO;
  context?: ObjectContextDTO;
  //document: DocumentDTO;
  division: DivisionDTO;
  award: AwardDTO;
  unitPrice: UnitPriceDTO[] = [];

  static patchDTO(dto: CodeInclusionDTO): CodeInclusionDTO {
    if (!dto) {
      dto = new CodeInclusionDTO();
      dto.award = new AwardDTO();
    }
    return dto;
  }

  contructor() {
    CodeInclusionDTO.patchDTO(this);
  }

}

export class EndorsementInvoiceDTO implements BaseObjectDTO<string> {
  identifier: any;

  division: DivisionDTO;
  documentClass: DocumentClassDTO;
  orderNumber: number;


  nit: String;
  bankType: String;
  ordinalBank: String;
  description: String;

  links: Link[];
  task: TaskDTO;
}


export interface WorkCodeInclusionDTO extends BaseObjectDTO<string> {
  identifier: string;
  codeInclusion: CodeInclusionDTO;
  context?: ObjectContextDTO;
}